import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./leavetype.css";
import RegisterTextbox from "../../components/RegisterTextBox";
import { Form, Spinner } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import Title from "../../components/title";
import CustomButton from "../../components/CustomButton";
import { useEffect, useState } from "react";
import API from "../../api/axiosConfig";

function EditLeave() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState({});
  const [message, setMessage] = useState("");
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [days, setDays] = useState(0);
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchLeave = async () => {
      try {
        const res = await API.get(`/vacations/${id}`);
        if (res.status === 200) {
          const data = res.data;
          setName(data.name || "");
          setDescription(data.description || "");
          setDays(data.days || 0);
        }
      } catch (err) {
        console.error(err);
        setMessage("تعذر تحميل بيانات الاجازة");
      }
    };
    fetchLeave();
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const mFormData = new FormData();
    mFormData.append("id", id);
    mFormData.append("name", name);
    mFormData.append("description", description);
    mFormData.append("days", days);

    try {
      const res = await API.post("/vacations/update", mFormData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (res.status === 200) {
        navigate("/hrreport/vacdetails"); 
      } else {
        setError(res.data.errors);
      }
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.errors || {});
      setMessage(err.response?.data?.message || "حدث خطأ");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div className="investigations">
        <Title
          title="تعديل إجازة"
          icon={<FontAwesomeIcon icon={faPlusCircle} />}
        />

        <Form
          className="investigationsContainer"
          onSubmit={handleSubmit}
          encType="multipart/form-data"
        >
          <RegisterTextbox
            parentStyle={{ width: "25%", marginBottom: "20px" }}
            id="name"
            label="اسم الاجازة"
            type="text"
            stylee={{ width: "30%" }}
            name="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            error={error?.name}
          />

          <RegisterTextbox
            parentStyle={{ width: "25%", marginBottom: "20px" }}
            id="leaveDesc"
            label="وصف الاجازة"
            type="text"
            stylee={{ width: "30%" }}
            name="description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            error={error?.description}
          />

          <RegisterTextbox
            parentStyle={{ width: "25%" }}
            id="days"
            label="عدد الايام"
            type="number"
            stylee={{ width: "40%" }}
            name="days"
            value={days}
            onChange={(e) => setDays(e.target.value)}
            error={error?.days}
          />

          {isSubmitting ? (
            <Spinner animation="border" variant="primary" />
          ) : (
            <CustomButton text="حفظ" className="addClientBtn" />
          )}

          {message && <div className="error">{message}</div>}
        </Form>
      </div>
    </>
  );
}

export default EditLeave;
